import React from 'react';
import { FormattedMessage } from 'react-intl';

import { PhoneType, Value } from '@/model/common';

import SubjectItem from '../SubjectItem';

interface SenderItemProps {
  'data-test'?: string;
  value?: Value<{
    phone: PhoneType;
    name?: string;
  }>;
  readonly?: boolean;
  onChange?: (value: string) => Promise<void> | void;
}

const SenderItem: React.FC<SenderItemProps> = (props: SenderItemProps) => (
  <SubjectItem
    {...props}
    shortPhoneMask
    messages={{
      label: <FormattedMessage id="withdrawal.fields.sender.label" />,
      phoneLabel: <FormattedMessage id="withdrawal.fields.sender.phone.label" />,
      phoneError: <FormattedMessage id="withdrawal.fields.sender.phone.error" />,
    }}
  />
);

export default SenderItem;
